// extracted by mini-css-extract-plugin
module.exports = {"inventory_filter":"TableFilter_inventory_filter__2v5g2"};